forms-orders-status
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="forms_orders_status.inputs.method")
    inputs-hidden(tag-scope="forms_orders_status.inputs.authenticity_token")
    inputs-complex-radio-status(tag-scope="forms_orders_status.inputs.status" label="{this.opts.inputs.status.label}" items="{this.opts.inputs.status.items}" name="{this.opts.inputs.status.name}" value="{this.opts.inputs.status.value}")
    input(type="hidden" name="refresh" value="{opts.refresh}")
    inputs-submit(tag-scope="forms_orders_status.inputs.submit")
  script(type="typescript").
    this.mixin('forms.orders.status');
  style(scoped).
    .phase_wrap {
      padding: 1rem 0;
      display: none;
    }
    .phase_wrap.show {
      display: block;
    }
    .phase_wrap .row > label span {
      border-bottom: 4px solid #CCC;
    }
